var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "stage-new-list" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [_vm._t("default")], 2),
    _vm._v(" "),
    _c("tfoot"),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td", { staticClass: "stage__col stage__col_name" }, [
          _vm._v("Название этапа"),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "stage__col stage__col_related" }, [
          _vm._v("Предыдущие этапы"),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "stage__col stage__col_responsible" }, [
          _vm._v("Ответственный"),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "stage__col stage__col_duration" }, [
          _vm._v("Срок в днях"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }